import { METRIC_OPTIONS } from './components/MetricsChart'

export const CREDIT_PULLS_METRIC = 'creditPulls'

export const METRIC_OPTIONS_WITH_CREDIT_PULLS = [
  ...METRIC_OPTIONS,
  { value: CREDIT_PULLS_METRIC, label: 'Credit Pulls' },
]

export const metricOptionsFor = (creditPullsOn) => (
  creditPullsOn ? METRIC_OPTIONS_WITH_CREDIT_PULLS : METRIC_OPTIONS
)
